var map = {
	"./Menuchat.svg": "afd1",
	"./SendComment.svg": "5818",
	"./Ticket.png": "1edd",
	"./aprendizaje.png": "434e",
	"./background-login.png": "945f",
	"./background-login.webp": "4ed5",
	"./background-login2.png": "7cfe",
	"./barra-menu.svg": "4b3b",
	"./buho.png": "6516",
	"./buscador1.png": "b62e",
	"./carrito-compra.svg": "584a",
	"./carta.svg": "1c64",
	"./casa.svg": "27b8",
	"./certi.svg": "081a",
	"./certificate.svg": "9254",
	"./comment.svg": "cf89",
	"./contacto.svg": "ff07",
	"./copa_bronce.png": "b468",
	"./copa_oro.png": "0775",
	"./copa_plata.png": "8aac",
	"./courses.svg": "0bc5",
	"./cup.svg": "bd8f",
	"./curso-p.png": "254d",
	"./cursos.jpg": "c8a8",
	"./cursos/curso-codigos-de-vestimenta.png": "4664",
	"./cursos/curso-marca-personal.png": "0b9a",
	"./cursos/curso-ortografia.png": "8736",
	"./cursos/curso-presentacion-persona.png": "7ff0",
	"./cursos/curso-redes-sociales.png": "cd40",
	"./estadisticas.svg": "5030",
	"./estrella.svg": "f888",
	"./examen-1.svg": "b369",
	"./examen-2.svg": "35a3",
	"./first_trophy.svg": "b957",
	"./flecha-abajo.png": "8f42",
	"./free.png": "9c34",
	"./handsome-guy.png": "a219",
	"./help.png": "3a63",
	"./home.svg": "86e6",
	"./icon-coin.png": "b364",
	"./icon-first.png": "0834",
	"./icon-second.png": "f37b",
	"./icon-third.png": "d234",
	"./image60.png": "f928",
	"./jovenes11.webp": "3167",
	"./lead_down_arrow.svg": "47e7",
	"./list-disc.svg": "2960",
	"./logo-aula.png": "6975",
	"./logo-aula3.png": "4a66",
	"./logo-aula4.jpeg": "6d7e",
	"./logo-aula5.png": "38a7",
	"./logo-bandera.svg": "3d2b",
	"./logo-comment.svg": "55af",
	"./logo-inicial.png": "d042",
	"./logo-king.png": "2c77",
	"./logo-lapiz.svg": "7372",
	"./logo-perfil.png": "7364",
	"./logo-puntos.png": "e1cc",
	"./logo.png": "cf05",
	"./logro.png": "21ff",
	"./logros.svg": "f64a",
	"./medalla.svg": "4522",
	"./medalla1.png": "5103",
	"./medalla2.png": "c59e",
	"./medalla3.png": "0a5b",
	"./messange.svg": "e4ce",
	"./name-aula.svg": "a7a7",
	"./no-image.jpg": "cbf6",
	"./notification - copia.png": "6e44",
	"./notification.png": "203a",
	"./perfil-del-usuario.png": "96cb",
	"./perfil.png": "42c4",
	"./promo.webp": "2500",
	"./promolider.png": "d27f",
	"./promolider_logo.png": "4a2c",
	"./promolider_logo_2.png": "e657",
	"./question-mark-avatar.svg": "c2ab",
	"./roles-permisos.svg": "b865",
	"./ruleta.png": "e469",
	"./ruletaVerde.png": "121a",
	"./sales.svg": "821f",
	"./second_trophy.svg": "58f4",
	"./send.svg": "ad0d",
	"./share-icon.png": "5275",
	"./stars.svg": "2213",
	"./subcription.png": "59ae",
	"./subcription.png.sketch": "297b",
	"./testRanking.jpg": "7c18d",
	"./third_trophy.svg": "906d",
	"./transparent.png": "fd97",
	"./trophy.png": "95e9",
	"./userico.svg": "1a80",
	"./water-background.webp": "4420",
	"./welcome1.jpg": "83e1",
	"./welcome2.jpg": "4592"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";